import { Tooltip, TooltipProps } from "antd"
import { memo } from "react"

function CustomTooltip(props: TooltipProps) {
  const { title, children, classNames, ...rest } = props
  return (
    <Tooltip
      title={title}
      classNames={{
        ...classNames,
        body: `!bg-dark-2 dark:!bg-genesis !text-dark-6 dark:!text-dark-2${classNames?.body ? ` ${classNames?.body}` : ""}`
      }}
      {...rest}
      destroyOnHidden
    >
      {children}
    </Tooltip>
  )
}

export default memo(CustomTooltip)
